import { FC } from 'react';

import { Icon } from 'common/components';
import { EntityType } from 'common/enums';
import {
    DEFAULT_HIERARCHY_OFFSET_CATEGORY,
    DEFAULT_HIERARCHY_OFFSET_INDICATOR,
    DEFAULT_HIERARCHY_OFFSET_SUBCATEGORY
} from 'common/config';
import { ICON_COLLECTION } from 'assets/media/icons';
import ParentIndicator from 'assets/media/icons/ParentIndicator.svg';
import ChildIndicator from 'assets/media/icons/Indicator.svg';

import './NameCellRenderer.scss';

type NameCellRendererProps = {
    value: string;
    data: any;
    onExpansionToggle: (data: any) => void;
};

const NameCellRenderer: FC<NameCellRendererProps> = ({
    value,
    data,
    onExpansionToggle
}: NameCellRendererProps) => {
    const cellStyles = {
        marginLeft: `${
            data.level === 0
                ? DEFAULT_HIERARCHY_OFFSET_CATEGORY
                : data.entityType === EntityType.Indicator
                ? data.level * DEFAULT_HIERARCHY_OFFSET_INDICATOR
                : data.level * DEFAULT_HIERARCHY_OFFSET_SUBCATEGORY
        }px`
    };
    const expansionIndicationClass =
        data.isParentExpanded || data.isExpanded ? 'name-cell-expanded' : '';

    const nameValueClass = `name-value ${
        data.isExpanded
            ? 'name-value-expanded'
            : data.entityType === EntityType.Indicator
            ? 'name-value-light'
            : ''
    }`;

    const showLinkIcon = () => {
        if (data.entityType === EntityType.Indicator) {
            if (data.isChildLink === false) {
                return <img src={ParentIndicator} className="link-icon" />;
            } else if (data.isChildLink === true) {
                return <img src={ChildIndicator} className="link-icon" />;
            } else {
                return <span className="link-icon" />;
            }
        }
    };

    return (
        <div className={`name-cell ${expansionIndicationClass}`} title={value}>
            <div className="name-cell-contents" style={cellStyles}>
                {data.hasChild ? (
                    data.isExpanded ? (
                        <Icon
                            className="name-icon name-icon-expanded"
                            src={ICON_COLLECTION.IC_ExpandMore}
                            onClick={() => onExpansionToggle(data)}
                        />
                    ) : (
                        <Icon
                            className="name-icon"
                            src={ICON_COLLECTION.IC_ChevronRight}
                            onClick={() => onExpansionToggle(data)}
                        />
                    )
                ) : (
                    <span className="name-icon empty" />
                )}
                <span className="name-container">
                    {showLinkIcon()} <span className={nameValueClass}>{value}</span>
                </span>
            </div>
        </div>
    );
};
export default NameCellRenderer;
